import React from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';

const UserMealCard = ({ meal, onView, onDelete }) => {
    // Helper function to ensure we always have arrays
    const ensureArray = (value) => {
        if (!value) return [];
        return Array.isArray(value) ? value : [value];
    };

    return (
        <Card
            title={meal.title}
            style={{ margin: '1rem 0', height: '100%' }}
            className="recipe-card custom-meal"
            footer={(
                <div className="card-actions">
                    <Button
                        icon="pi pi-eye"
                        style={{ gap: '0.5rem' }}
                        label="View"
                        className="p-button-text"
                        onClick={(e) => {
                            e.stopPropagation();
                            const mealWithArrays = {
                                ...meal,
                                ingredients: ensureArray(meal.ingredients),
                                instructions: ensureArray(meal.instructions)
                            };
                            onView(mealWithArrays);
                        }}
                    />
                    <Button
                        icon="pi pi-trash"
                        className="p-button-text p-button-danger"
                        onClick={(e) => {
                            e.stopPropagation();
                            onDelete(meal);
                        }}
                    />
                </div>
            )}
        >
            <div className="recipe-card-content">
                {meal.image && (
                    <img src={meal.image} alt={meal.title} className="recipe-image" />
                )}
                <div className="custom-meal-info">
                    <p><strong>Type:</strong> {meal.mealType}</p>
                    <p><strong>Prep Time:</strong> {meal.prepTime} minutes</p>
                    <p><strong>Servings:</strong> {meal.servings}</p>
                </div>
            </div>
        </Card>
    );
};

export default UserMealCard; 